import { render, staticRenderFns } from "./MemberEditIframe.vue?vue&type=template&id=06cfc283&"
import script from "./MemberEditIframe.vue?vue&type=script&lang=ts&"
export * from "./MemberEditIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports